'use client'

import { DOCS_LOCALE_NAMES, i18n } from '@/lib/docs-i18n'

type DocsLanguageToggleProps = {
  locale: (typeof i18n.languages)[number]
  onChange: (nextLocale: string) => void
}

/** EN/DE segmented control — same pattern as `LanguageSwitcher` on `/`. */
export function DocsLanguageToggle({ locale, onChange }: DocsLanguageToggleProps) {
  return (
    <div
      className="inline-flex items-center rounded-md border border-neutral-200 bg-background p-0.5 shadow-sm"
      role="group"
      aria-label="Language"
    >
      {i18n.languages.map((code) => {
        const active = code === locale
        return (
          <button
            key={code}
            type="button"
            aria-pressed={active}
            aria-label={DOCS_LOCALE_NAMES[code]}
            onClick={() => onChange(code)}
            className={`rounded px-2 py-1 text-xs font-medium transition-colors ${
              active
                ? 'bg-muted text-foreground'
                : 'text-muted-foreground hover:bg-accent/40 hover:text-foreground'
            }`}
          >
            {code.toUpperCase()}
          </button>
        )
      })}
    </div>
  )
}
